export default __webpack_public_path__ + "static/media/wegovy-outercap-remove.769698be.mp4";